import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../Components/common/Header/Header";

const AccessDenied = () => {
	const navigate = useNavigate();

	return (
		<div>
			<Header theme="light" />
			<div className="container text-center mt-4">
				<h1>Oops!</h1>
				<p>You do not have the permission to access this resource.</p>
				<button className="btn theme-btn" onClick={() => navigate(-2)}>
					Go back
				</button>
			</div>
		</div>
	);
};

export default AccessDenied;
